import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import store from '../store/index';
import router from '../router/index';

// axios配置
axios.defaults.timeout = 100000;
axios.defaults.baseURL = '/api/';
axios.defaults.withCredentials = true;

// 请求拦截器
axios.interceptors.request.use(
  async (req) => {
    req.headers.clientToken = 'Basic YW5kcm9pZDphbmRyb2lk';
    req.headers.Authorization = Cookies.get('token') || '';
    req.headers['x-language-header'] = Cookies.get('langCode') || '';
    // 账号登录、微信登录、绑定用户、接口都需要再head带version
    const allowedUrls = [
      // 账号登录、微信登录、绑定用户、接口都需要再head带version
      apis.Login,
      apis.WechatLogin,
      apis.BindUser,
      // 运行记录年月季周日 导出
      apis.portalDeviceReportDailyPage,
      apis.portalDeviceReportSummaryPage,
      apis.portalDeviceReportDailyExport,
      apis.portalDeviceReportSummaryExport
    ];

    if (allowedUrls.includes(req.url)) {
      req.headers.version = 2;
    }
    // req.headers.hostIp = localStorage.hostIp || '192.168.11.127'; // 张鹏
    // req.headers.hostIp = localStorage.hostIp || '192.168.11.130'; // 阿康
    req.headers.hostIp = localStorage.hostIp || '192.168.11.132'; // 呆萌

    // 刷新token
    const now = Number(moment(Date.now()).format('X'));
    const isNotRefresh = req.url !== '/base/token/refresh';
    if (Cookies.get('token') && Cookies.get('tokenTimeOut') && now >= Cookies.get('tokenTimeOut') && isNotRefresh) {
      await store.dispatch('TokenRefresh');
      req.headers.Authorization = Cookies.get('token') || '';
    }
    return req;
  },
  err => Promise.reject(err)
);
// 响应拦截器
axios.interceptors.response.use(
  (res) => {
    if (res.data && res.data.code === 0) {
      return res;
    }
    // 408是微信登录跳转绑定
    if (res.data && res.data.code === 408) {
      return res;
    }
    // 鲁班通上传
    if (res.data && res.data.msg === '操作成功') {
      return res;
    }
    if (res.data && res.data.code) {
      // 401token错误  405token已经完全过期
      if (res.data.code === 401 || res.data.code === 405) {
        store.commit('LOGINOUT');
        Cookies.remove('loginName', { path: '/' });
        Cookies.remove('token', { path: '/' });
        Cookies.remove('tokenTimeOut', { path: '/' });
        Cookies.remove('langCode', { path: '/' });
        if (router.currentRoute.path !== '/login') {
          router.replace({ path: '/login' });
        }
        return Promise.reject(res.data);
      }
      const vm = new Vue();
      vm.$message.error(res.data.msg || '服务异常');
      return Promise.reject(res.data);
    }
    return res;
  },
  err => Promise.reject(err.response)
);
export default axios;
